import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CATEGORIES = {
  groceries: { label: "Groceries & Errands", icon: "shopping-basket", color: "text-terracotta" },
  transport: { label: "Transport & Mobility", icon: "car-front", color: "text-forest-700" },
  companionship: { label: "Companionship", icon: "heart-handshake", color: "text-gold" },
};

export const STATUS_LABEL = {
  open: "Open",
  connected: "Connected",
  in_progress: "In progress",
  completed: "Completed",
};

export function fileUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
}

export const TRUST = {
  unverified: { label: "New member", short: "New", color: "#5C7668", bg: "#EFECE4", icon: "user" },
  basic: { label: "Basic Member", short: "Basic", color: "#1C3B2B", bg: "#E4EDE7", icon: "badge-check" },
  id_verified: { label: "ID Verified", short: "Verified", color: "#1D6FB8", bg: "#DCEBF7", icon: "shield-check" },
  trusted: { label: "Trusted Helper", short: "Trusted", color: "#B3361E", bg: "#F7E6DF", icon: "star" },
  champion: { label: "Community Champion", short: "Champion", color: "#9A6A00", bg: "#F7EAD1", icon: "award" },
};
